import type { SVGProps } from "react";
import * as React from "react";

const SvgEye = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="m1 12-.894-.447a1 1 0 0 0 0 .894zm22 0 .894.447a1 1 0 0 0 0-.894zM1 12l.894.448v-.002l.007-.012.03-.056q.04-.079.126-.232a18.678 18.678 0 0 1 2.547-3.463C6.397 6.774 8.9 5 12 5V3C8.1 3 5.104 5.226 3.145 7.316a20.7 20.7 0 0 0-2.831 3.85 12 12 0 0 0-.206.383l-.002.002v.001zm11-7c3.1 0 5.605 1.774 7.395 3.684a18.7 18.7 0 0 1 2.548 3.463q.086.153.127.23l.029.057.006.012.001.002L23 12l.894-.448q0-.002-.002-.003l-.003-.007-.011-.022a11 11 0 0 0-.192-.354 20.675 20.675 0 0 0-2.831-3.85C18.895 5.226 15.899 3 12 3zm11 7-.894-.448v.002l-.007.012-.03.056q-.04.079-.126.232a18.684 18.684 0 0 1-2.547 3.463C17.604 17.226 15.1 19 12 19v2c3.9 0 6.895-2.226 8.855-4.316a20.7 20.7 0 0 0 2.831-3.85 12 12 0 0 0 .192-.354l.011-.022.003-.007.002-.002v-.001zm-11 7c-3.1 0-5.604-1.774-7.395-3.684a18.7 18.7 0 0 1-2.548-3.463 10 10 0 0 1-.156-.287l-.006-.012-.001-.002L1 12l-.894.448q0 .002.002.003l.014.03a8 8 0 0 0 .192.353 20.67 20.67 0 0 0 2.831 3.85C5.105 18.774 8.1 21 12 21zm2-7a2 2 0 0 1-2 2v2a4 4 0 0 0 4-4zm-2 2a2 2 0 0 1-2-2H8a4 4 0 0 0 4 4zm-2-2a2 2 0 0 1 2-2V8a4 4 0 0 0-4 4zm2-2a2 2 0 0 1 2 2h2a4 4 0 0 0-4-4z"
    />
  </svg>
);
export default SvgEye;
